import React from "react";
import Icon from "components/AppIcon";
import { getClientsService } from "redux/services/clients_service";
import { useDispatch } from "react-redux";

const translations = {
  en: {
    searchPlaceholder: "Search clients...",
    allStatus: "All Status",
    active: "Active",
    endingSoon: "Ending Soon",
    expired: "Expired",
    dateRange: "Date Range:",
    clear: "Clear",
    to: "to",
  },
  ar: {
    searchPlaceholder: "ابحث عن العملاء...",
    allStatus: "جميع الحالات",
    active: "نشط",
    endingSoon: "ستنتهي قريبًا",
    expired: "منتهية",
    dateRange: "نطاق التاريخ:",
    clear: "مسح",
    to: "إلى",
  },
};

const FilterToolbar = ({ filters, onFiltersChange, language }) => {
  const dispatch = useDispatch();

  const handleSearchChange = (e) => {
    onFiltersChange((prev) => ({ ...prev, search: e.target.value }));
    dispatch(getClientsService({ search: e.target.value }));
  };

  const handleStatusChange = (e) => {
    const status = e.target.value;
    onFiltersChange((prev) => ({ ...prev, status }));
    dispatch(
      getClientsService({
        status,
        start_date: filters.dateRange.start,
        end_date: filters.dateRange.end,
        search: filters.search,
      })
    );
  };

  const handleDateRangeChange = (field, value) => {
    onFiltersChange((prev) => ({
      ...prev,
      dateRange: { ...prev.dateRange, [field]: value },
    }));
    // Dispatch the action with updated date range
    dispatch(
      getClientsService({
        status: filters.status,
        start_date: field === "start" ? value : filters.dateRange.start,
        end_date: field === "end" ? value : filters.dateRange.end,
        search: filters.search,
      })
    );
  };

  const clearFilters = () => {
    onFiltersChange({
      search: "",
      status: "",
      dateRange: { start: "", end: "" },
    });
    // Dispatch action to fetch clients with cleared filters
    dispatch(
      getClientsService({
        status: "",
        start_date: "",
        end_date: "",
        search: "",
      })
    );
  };

  const handleSearch = (val) => {
    dispatch(getClientsService({ search: val }));
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex flex-col sm:flex-row gap-4 flex-1">
          {/* Search Input */}
          <div className="relative flex-1 max-w-md">
            <div
              className={`absolute inset-y-0 ${
                language === "ar" ? "right-0 pr-3" : "left-0 pl-3"
              } flex items-center pointer-events-none`}
            >
              <Icon name="Search" size={20} className="text-gray-400" />
            </div>
            <input
              type="text"
              placeholder={translations[language].searchPlaceholder}
              onChange={handleSearchChange}
              className={`py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent ${
                language === "ar" ? "pr-10 pl-4 text-right" : "pl-10 pr-4"
              }`}
            />
          </div>

          {/* Status Filter */}
          <div className="min-w-0 sm:min-w-[150px]">
            <select
              value={filters.status}
              onChange={handleStatusChange}
              className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm"
            >
              <option value="">{translations[language].allStatus}</option>
              <option value="active">{translations[language].active}</option>
              <option value="end soon">
                {translations[language].endingSoon}
              </option>
              <option value="inactive">{translations[language].expired}</option>
            </select>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 lg:items-center">
          {/* Date Range */}
          <div className="flex flex-col sm:flex-row gap-2 items-center">
            <label className="text-sm font-medium text-gray-700 whitespace-nowrap">
              {translations[language].dateRange}
            </label>
            <div className="flex gap-2">
              <input
                type="date"
                value={filters.dateRange.start}
                onChange={(e) => handleDateRangeChange("start", e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm"
              />
              <span className="text-gray-500 self-center">
                {translations[language].to}
              </span>
              <input
                type="date"
                value={filters.dateRange.end}
                onChange={(e) => handleDateRangeChange("end", e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 text-sm"
              />
            </div>
          </div>

          {/* Clear Filters */}
          <button
            onClick={clearFilters}
            className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
          >
            <Icon name="X" size={16} className="mr-1" />
            {translations[language].clear}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;
